module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sec_chap"
  }, [_vm._v("List of Tables")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("The 20th Army’s Composition as of 6 August")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Daily Correlation of Forces on 20th Army’s Front")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Equipment withdrawn from the Western Bank to the Eastern Bank of the Dnepr River by 20th Army")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("20th Army’s Combat Composition on 15 August 1941")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("A List of the Trophy [Captured] Property Seized by 19th Army’s Formations during the Period from 17 through 30 August 1941")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c706168","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_List_Tables.vue
// module id = 78
// module chunks = 0